import React, { useContext, useRef, useEffect } from 'react';
import { KICK_TYPE } from '../../constants/constants';
import { KickCounterContext } from '../../context/KickCounterContext';
import styles from './KickList.module.css';

const generalIcon = require('../../assets/icons/general.svg').default;
const flutterIcon = require('../../assets/icons/flutter.svg').default;
const kickIcon = require('../../assets/icons/kick.svg').default;
const swishIcon = require('../../assets/icons/swish.svg').default;
const rollIcon = require('../../assets/icons/roll.svg').default;
const trashIcon = require('../../assets/icons/trash.svg').default;

export default function KickList({ backgroundColor = 'white' }) {
  const { kickList, deleteKick } = useContext(KickCounterContext);
  const elementRef = useRef();

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const prevCount = usePrevious(kickList.length);
  const mql = window.matchMedia('(max-width: 900px)');

  const deleteItem = (id) => {
    deleteKick(id);
  };

  const getIcon = (kickType) => {
    switch (kickType) {
      case KICK_TYPE.GENERAL:
        return generalIcon;
      case KICK_TYPE.FLUTTER:
        return flutterIcon;
      case KICK_TYPE.KICK:
        return kickIcon;
      case KICK_TYPE.SWISH:
        return swishIcon;
      case KICK_TYPE.ROLL:
        return rollIcon;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (prevCount < kickList.length && !mql.matches) {
      elementRef.current.scrollIntoView();
    }
  }, [kickList]);

  return (
    <div className={styles.kickList} style={{ backgroundColor }}>
      <ul>
        {kickList.map((item) => (
          <li key={item.id} className={styles.listItem}>
            <div className={styles.kickType}>
              <img src={getIcon(item.kickType)} alt="" />
              {item.kickType}
            </div>
            <div className={styles.timestamp}>
              <span>
                { item.timestamp >= 3600 && `${Math.floor(item.timestamp / (60 * 60))}:`}
              </span>
              <span>
                {`0${Math.floor((item.timestamp / 60) % 60)}`.slice(-2)}
                :
              </span>
              <span>{`0${item.timestamp % 60}`.slice(-2)}</span>
            </div>
            <div className={styles.deleteButtonContainer}>
              <button type="button" aria-label="delete" className={styles.deleteButton} onClick={() => deleteItem(item.id)}>
                <img src={trashIcon} alt="" />
              </button>
            </div>
          </li>
        ))}
        <div ref={elementRef} />
      </ul>
    </div>
  );
}
